module.exports = __webpack_public_path__ + "img/contact10.8b2c76e6.png";